import styled from 'styled-components'

export const Container = styled.div`
  max-height: 330px;
  overflow: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  margin: 0 -20px;
  padding: 0 20px;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
`
